import {types} from './types';

const initialState = {
    list: {
        data: [],
        page: 1
    },
}

export function freespinReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_FREESPIN:
            return { ...state, list: action.payload};
        default:
            return state
    }
}